import { createStore } from 'redux';
import todoApp from './reducers';
const store = initialState => createStore(todoApp, initialState);
export default store;
